import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';

import { CommonService } from 'src/app/services/common/common.service';
import { UserManagementService } from 'src/app/services/user_management/user-management.service';
import { AddUserComponent } from '../add-user/add-user.component';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-import-csv',
  templateUrl: './import-csv.component.html',
  styleUrls: ['./import-csv.component.scss']
})
export class ImportCsvComponent {

files: File[] = [];
public isSpinnerLoading:boolean=false;
public errorMsg:string=''
constructor(private userService:UserManagementService,private commonService :CommonService,private dialog:MatDialog,
  public dialogRef: MatDialogRef<ImportCsvComponent>, 
  private spinner:NgxSpinnerService,    @Inject(MAT_DIALOG_DATA) public dialogData: any,){}
ngOnInit(): void {
  //Called after the constructor, initializing input properties, and the first call to ngOnChanges.
  //Add 'implements OnInit' to the class.
}
onSelect(event: any) {
  if (this.files.length == 0) {
    this.files.push(...event.addedFiles);
    this.errorMsg=''
  }
  else {
    this.files = [];
    this.files.push(...event.addedFiles);
  }
  const fileSizeInKB: number = this.files[0]["size"] / (1024 * 1024);
}
onRemove(event: any) {
  this.files.splice(this.files.indexOf(event), 1);
}
onSave(){
  let formData = new FormData();
  formData.append('file', this.files[0]);
  formData.append('u_t',this.dialogData.userType)
  this.errorMsg=''
  if(this.files.length>0){
    // this.isSpinnerLoading=true
    this.spinner.show()
    this.userService.checkCSV(formData).subscribe({
      next: (success: any) => {
        if (success.status == 200) {
          // this.isSpinnerLoading=false
          this.spinner.hide();
          // this.appService.showToastMessage("success", success.msg);
          this.addUser(success.msg)
        }
      },
      error: (error: any) => {
        this.spinner.hide();
        this.isSpinnerLoading=false
        this.commonService.handleError(error);
      },
    });
  }
  else{
    this.errorMsg="Please choose a file to import users."
  }
}
addUser(data){
  const dialogRef = this.dialog.open(AddUserComponent, {
    enterAnimationDuration: '300ms', exitAnimationDuration: "300ms",
    data: { userType:this.dialogData.userType,data ,dataType:'csv'},
    autoFocus:false,
    width: '90%',
    height: '90%',
  });
  dialogRef.afterClosed().subscribe(result => {
    this.dialogRef.close();
  });
}
}
